import * as React from 'react';
import Table from '../Dashboard/BookTimeOff/OtherLeaves/Table';
import ResponsiveModal from './ResponsiveModal';

export default class OtherLeavesTable extends ResponsiveModal {
    getContent() {
        return (<Table otherLeaves={{ value: this.props.leaves }} showAll={true} />);
    }
}